import { Button, ButtonProps, CircularProgress } from '@mui/material'
import React from 'react'

interface Props extends ButtonProps {
  loading?: boolean
}

export const StatefulButton: React.FC<Props> = ({
  loading,
  children,
  ...rest
}) => {
  return (
    <Button disabled={loading} {...rest}>
      {loading && (
        <CircularProgress sx={t => ({ marginRight: t.spacing(1) })} size={20} />
      )}
      {children}
    </Button>
  )
}
